<template>
  <div class="feature-flags-view">
    <FormGroup group-title="Configurações de console">
      <FormItem>
        <OptionTitle>
          <div class="title">
            Nível de mensagens

            <select v-model="selectedOption">
              <option v-for="opt in options" :key="opt">
                {{ opt }}
              </option>
            </select>
          </div>
        </OptionTitle>

        <OptionInfo>
          <p>
            Usando a opção selecionada, somente as mensagens dos grupos a seguir serão exibidas:
          </p>

          <div class="log-groups">
            <span
              v-for="group in logMethodsInfo"
              :key="group.name"
              :class="['log-group', group.name, { disabled: group.disabled }]"
            >
              {{ group.name }}
            </span>
          </div>
        </OptionInfo>
      </FormItem>
    </FormGroup>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  ref, watchEffect,
} from 'vue';

import { LogLevel, logMethods } from '@/logger';
import useDevOverlayStore from '@/stores/devOverlay';

import { FormGroup, FormItem } from '../form';
import { OptionInfo, OptionTitle } from '../typography';

export default defineComponent({
  components: {
    FormGroup,
    FormItem,
    OptionInfo,
    OptionTitle,
  },
  setup() {
    const devOverlayStore = useDevOverlayStore();

    const sortedLevels = (Object.keys(logger.levels) as LogLevel[])
      .sort((a, b) => logger.levels[a] - logger.levels[b]);

    const options = ['', ...sortedLevels] as const;
    const selectedOption = ref<typeof options[number]>(
      devOverlayStore.config.logLevel ?? options[0],
    );

    const logMethodsInfo = computed(() => {
      const selectedLevel = !selectedOption.value
        ? logger.defaultLevel
        : logger.levels[selectedOption.value];
      return logMethods.map((name) => ({ name, disabled: logger.levels[name] < selectedLevel }));
    });

    watchEffect(() => {
      const newLevel = selectedOption.value;
      devOverlayStore.config.logLevel = !newLevel ? undefined : newLevel;
    });

    return {
      options,
      logMethods,
      selectedOption,
      logMethodsInfo,
    };
  },
});
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
}

.log-groups {
  display: flex;
  gap: .5em;

  .log-group {
    border-radius: 99em;
    padding: .1em .7em;

    &.disabled {
      opacity: 0.3;
    }

    &.debug {
      background: #6663;
    }

    &.info {
      background: #0396;
    }

    &.log {
      background: #0606;
    }

    &.warn {
      background: #9606;
    }

    &.error {
      background: #c306;
    }
  }
}
</style>
